import { ActionTree, GetterTree, MutationTree } from 'vuex'
import { RootState } from '~/types/store'
import { UserSubjectTool } from '~/types/subject-tools'

export interface IdiomState {
  userIdioms: UserSubjectTool[]
  activeSubjectIdiom: UserSubjectTool | Record<string, never>
}

export function state (): IdiomState {
  return ({
  userIdioms: [],
  activeSubjectIdiom: {}
})
}

export const mutations: MutationTree<IdiomState> = {
  SET_IDIOMS (state, data: UserSubjectTool[]) {
    state.userIdioms = data;
  },
  SET_ACTIVE_SUBJECT_IDIOM (state, data: UserSubjectTool) {
    state.activeSubjectIdiom = data;
  }
};

export const getters: GetterTree<IdiomState, RootState> = {
  getUserIdioms (state) {
    return state.userIdioms;
  },
  getActivatedUserIdioms (state) {
    return state.userIdioms.filter(Idiom => Idiom.isActive === true);
  },
  getActiveSubjectIdiom (state) {
    return state.activeSubjectIdiom;
  }
};

export const actions: ActionTree<IdiomState, RootState> = {
  async getIdioms ({ commit }) {
    try {
      const { data } = await this.$axios.get(
        '/v1/users/me/idioms'
      );
      commit('SET_IDIOMS', data);
    } catch (e) {
      console.error(e);
    }
  },
  async getIdiomById ({ commit }, id: number | string) {
    try {
      const { data } = await this.$axios.get(
        `/v1/users/me/idioms/${String(id)}`
      );
      commit('SET_ACTIVE_SUBJECT_IDIOM', data);
    } catch (e) {
      console.error(e);
    }
  }
};
